import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DomainProfileGuard } from './core/router/domain-profile.guard';
import { UrlGtmGuard } from './guard/url-gtm.guard';
import { AddLineTiscoComponent } from './pages/add-line-tisco/add-line-tisco.component';
import { TermsAndConditionComponent } from './pages/terms-and-condition/terms-and-condition.component';

const routes: Routes = [

    /*
    Route  allowPath ['mazda', 'ford', 'insure']
    /register/line/insure
    /register/line/insure/confirm-otp
    /register/line/insure/mobile-list
    /register/line/insure/completed
    /register/line/insure/new-user
	
    /register/line/mazda
    /register/line/mazda/confirm-otp
    /register/line/mazda/mobile-list
    /register/line/mazda/completed
    /register/line/mazda/new-user
	
    /register/line/ford
    /register/line/ford/confirm-otp
    /register/line/ford/mobile-list
    /register/line/ford/completed
    /register/line/ford/new-user
    */
    { path: 'renewal', loadChildren: () => import('./renewal/renewal.module').then(m => m.RenewalModule) },
    { path: 'register', loadChildren: () => import('./register/register.module').then(m => m.RegisterModule) },
    {
        path: ':comcode/terms',
        loadChildren: () => import('./pages/motorshow-terms/motorshow-terms.module').then(m => m.MotorshowTermsModule)
    },
    { path: 'claim', loadChildren: () => import('./claim/claim.module').then(m => m.ClaimModule) },
    {
        path: 'ford-motorshow/addline',
        component: AddLineTiscoComponent
    },
    {
        path: 'mazda-motorshow/addline',
        component: AddLineTiscoComponent
    },
    {
        path: 'mitsubishi-motorshow/addline',
        component: AddLineTiscoComponent
    },
    {
        path: 'motor/terms-and-condition/:comcode',
        component: TermsAndConditionComponent,
        canActivateChild: [UrlGtmGuard],
    },
    {
        path: ':quota/fullquota',
        loadChildren: () => import('./pages/motorshow-terms/motorshow-terms.module').then(m => m.MotorshowTermsModule)
    },
    {
        path: 'lon',
        loadChildren: () => import('./lon/lon.module').then(m => m.LonModule)
    },
    {
        path: '', 
        canLoad:[DomainProfileGuard],
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) 
    }
    
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    enableTracing: false,
    onSameUrlNavigation: 'reload',
    })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
